import { Injectable } from '@angular/core';
// import { environment } from 'environments/environment';
import * as firebase from 'firebase/app';
import * as fireMessage from 'firebase/messaging';
// import { TravelService } from '../travel/travel.service';
// import { TravelListComponentService } from '../travel/travelListComponent.service';
// import { PushNotificationIdentifierEnum } from 'app/enums/notification/push-notification-identifier.enum';
// import { NotificationsService } from './notifications.service';
// import { DriverLeftBase } from '../models/push-notification/driver-left-base.model';
// import { BasePushNotification } from '../models/push-notification/base-push-notification.model';
// import { DriverIsConfirmed } from '../models/push-notification/driver-is-confirmed.model';
// import { ExceededLimitModel } from '../models/push-notification/exceeded-limit.model';
// import { TravelProgrammedModel } from '../models/push-notification/travel-programmed.model';
// import { TravelLostModel } from '../models/push-notification/travel-lost.model';
// import { TravelProgrammedPickUpDelayModel } from '../models/push-notification/travel-programmed-pickup-delay.model';
// import { NotificationInformation } from '../models/push-notification/notification-information.model';
import { IdentityService } from '../authentication/identity.service';
import { Observable, catchError, delay, map, of, throwError } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { UpdateFirebaseTokenCommand } from '../authentication/command/updateFirebaseToken.command';
// import { ConnectionServices } from '../connection/connection.service';
import { TranslateService } from '@ngx-translate/core';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { environment } from 'environments/environment';

@Injectable()
export class PushNotificationService {
  titleMessage: string = 'info';
  constructor(
    // private notificationsService: NotificationsService,
    // private travelService: TravelService,
    // private travelListComponentService: TravelListComponentService,
    private identityService: IdentityService,
    private connectionService: ConnectionServices,
    private translateService: TranslateService
  ) {}

  initCloudMessages(): void {
    // if (!firebase.apps.length) {
    if (!firebase.getApps().length) {
      firebase.initializeApp(environment.firebase);

      this.identityService.firebaseToken = firebase.getApp().options.apiKey;

      // const messaging = fireMessage.onMessage();
      // fireMessage.getMessaging().app.options
      //   .then(() => {
      //     messaging
      //       .getToken()
      //       .then(currentToken => {
      //         this.identityService.firebaseToken = currentToken;
      //       })
      //       .catch(err => {});
      //   })
      //   .catch(err => {});

      // messaging.onMessage((param: any) => {
      //   let parseParam: BasePushNotification = JSON.parse(param.data.body);
      //   if(parseParam.userId == +this.identityService.userId){
      //     this.evaluateIdentifier(parseParam.notificationIdentifier, parseParam);
      //   }
      // });

      // messaging.onTokenRefresh((token: string) => {
      //   this.identityService.firebaseToken = token;
      //   this.updateFirebaseToken(token);
      // });

    }

  }

  private updateFirebaseToken(token){
    let updateTokenCommand = new UpdateFirebaseTokenCommand();
    updateTokenCommand.setParameters(token);
    return this.connectionService
      .Request(updateTokenCommand).pipe(
        map(res => {
          return new Observable<boolean>();
        }),
        catchError(error => {
          return throwError(() => false);
        })
    );
  }

  // public getToken(): any {
  //   // let messaging = firebase.messaging();
  //   return this.identityService.firebaseToken;
  //   // Observable.fromPromise(messaging.getToken())
  //   //   .map(result => {
  //   //     return result;
  //   //   })
  //   //   .catch(error => {
  //   //     console.error('Error al obtener el token de firebase' ,error);
  //   //     return Observable.of('INVALID_TOKEN');
  //   //   });
  // }

  public getToken(): Observable<any> {
    // let messaging = firebase.messaging();
    // return Observable.fromPromise(messaging.getToken())
    //   .map(result => {
    //     return result;
    //   })
      // .catch(error => {
        // console.error('Error al obtener el token de firebase' ,error);
    return of('INVALID_TOKEN').pipe(delay(100));
      // });
  }

  // private driverIsConfirmed(isConfirmed: boolean, notification: DriverIsConfirmed) {
  //   this.travelService.driverConfirmed(isConfirmed, notification.travelIdForCarrier);
  //   if (isConfirmed) {
  //     this.reloadTravelGrid();
  //   }
  // }

  // private evaluateIdentifier(
  //   notificationIdentifier: PushNotificationIdentifierEnum,
  //   data: any
  // ) {
  //   switch (notificationIdentifier) {
  //     // case PushNotificationIdentifierEnum.CANDIDATE_CONFIRM:
  //     //   this.driverIsConfirmed(true, data);
  //     //   break;
  //     // case PushNotificationIdentifierEnum.DRIVER_LEFT_BASE:
  //     //   this.driverLeftBase(data);
  //     //   break;
  //     case PushNotificationIdentifierEnum.TRAVEL_PROGRAMMED:
  //       this.remindTravelProgrammed(data);
  //       this.travelListComponentService._onNotify(data.travelId, new NotificationInformation(notificationIdentifier, 'Requiere asignación'))
  //       break;
  //     case PushNotificationIdentifierEnum.TRAVEL_LOST:
  //       this.notifyLostTrip(data);
  //       break;
  //     case PushNotificationIdentifierEnum.TRAVEL_DELAY:
  //       this.notifyTravelDelay(data);
  //       this.travelListComponentService._onNotify(data.travelId, new NotificationInformation(notificationIdentifier, 'En período de pérdida'))
  //       break;
  //     case PushNotificationIdentifierEnum.TRAVEL_PICKUPDELAY:
  //       this.notifyTravelPickupDelay(data);
  //       this.travelListComponentService._onNotify(data.travelId, new NotificationInformation(notificationIdentifier, 'Chofer demorado'))
  //       break;
  //     case PushNotificationIdentifierEnum.TRAVEL_WITH_DRIVER_DELAY:
  //       this.notifyTravelDelay(data);
  //       this.travelListComponentService._onNotify(data.travelId, new NotificationInformation(notificationIdentifier, 'Chofer demorado'))
  //       break;
  //     // case PushNotificationIdentifierEnum.CHECKING_ACCOUNT_EXCEEDING_LIMIT:
  //     //   this.notifyExceedingLimit(data);
  //     //   break;
  //     default:
  //       break;
  //   }
  // }

  // private driverLeftBase(notification: DriverLeftBase) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.driver_left_base')
  //       .replace('{driverName}', notification.driverName)
  //       .replace('{driverDomain}', notification.driverDomain)
  //   );
  // }

  // private notifyTravelPickupDelay(notification: TravelProgrammedPickUpDelayModel) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.driver_pick_up_delay')
  //       .replace('{driverName}', notification.driverName)
  //       .replace('{driverDomain}', notification.driverDomain)
  //       .replace('{travelIdForCarrier}', notification.travelIdForCarrier)
  //   );
  // }

  // private notifyTravelDelay(notification: TravelProgrammedModel) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.travel_delay')
  //       .replace('{travelIdForCarrier}', notification.travelIdForCarrier)
  //   );
  // }

  // private remindTravelProgrammed(notification: TravelProgrammedModel) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.programmed_assign_required')
  //       .replace('{travelIdForCarrier}', notification.travelIdForCarrier)
  //   );
  // }

  // private notifyLostTrip(notification: TravelLostModel) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.lost_trip')
  //       .replace('{travelIdForCarrier}', notification.travelIdForCarrier)
  //   );
  // }

  // private reloadTravelGrid() {
  //   this.travelListComponentService._update();
  // }

  // private notifyExceedingLimit(notification: ExceededLimitModel) {
  //   this.notificationsService.showProgrammedNotifications(
  //     this.titleMessage,
  //     this.translateService.instant('toast.info.message.exeeding_limit')
  //       .replace('{passengerId}', notification.passengerId)
  //       .replace('{passengerName}', notification.passengerName)
  //   );
  // }
}
